import { BaseBuyBonusPopup } from './BaseBuyBonusPopup';
import { landScapeConfig, webConfig } from '../../../core/applicationConfig';

export class BuyBonusLandscapePopup extends BaseBuyBonusPopup {
  constructor() {
    super();
    this.scales = [.35, .35, .35];
    this.space = 400;
  }
  execute({ root }) {
    const popup = this.getPopup({
      scale: 1.75,
      parentWidth: landScapeConfig.width ,
      parentHeight: landScapeConfig.height,
      mistakeY: -90,
    });
    root.addChild(popup);
  }
}
